import React, { useEffect, useState, useCallback } from 'react';
import { Modal, Spinner } from 'react-bootstrap';

// Očekávaný formát odpovědi z /videos-list.php:
// { success: true, videos: [ { id, youtube_id, title }, ... ] }
const Videos = () => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('/videos-list.php')
            .then((res) => res.json())
            .then((data) => {
                if (!data.success) {
                    throw new Error(data.message || 'Videa se nepodařilo načíst.');
                }
                setVideos(data.videos || []);
            })
            .catch(() => {
                setError('Videa se nepodařilo načíst.');
            })
            .finally(() => setLoading(false));
    }, []);

    const isOpen = selectedIndex !== null;

    const showPrev = useCallback(() => {
        setSelectedIndex((i) => (i === null ? null : (i - 1 + videos.length) % videos.length));
    }, [videos.length]);

    const showNext = useCallback(() => {
        setSelectedIndex((i) => (i === null ? null : (i + 1) % videos.length));
    }, [videos.length]);

    useEffect(() => {
        if (!isOpen) return;

        const handleKey = (e) => {
            if (e.key === 'ArrowLeft') showPrev();
            if (e.key === 'ArrowRight') showNext();
            if (e.key === 'Escape') setSelectedIndex(null);
        };

        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [isOpen, showPrev, showNext]);

    return (
        <div className="container my-5">
            <h1 className="hk-page-title">
                <i className="bi bi-play-circle me-2"></i>Videa
            </h1>

            {loading && (
                <div className="text-center my-5">
                    <Spinner animation="border" role="status" />
                </div>
            )}

            {!loading && error && (
                <p className="text-center text-danger">{error}</p>
            )}

            {!loading && !error && videos.length === 0 && (
                <p className="text-center">Zatím tu nejsou žádná videa.</p>
            )}

            {!loading && !error && videos.length > 0 && (
                <div className="row g-3">
                    {videos.map((video, index) => (
                        <div className="col-6 col-md-4 col-lg-3" key={video.id ?? video.youtube_id}>
                            <div
                                className="gallery-image video-thumb position-relative overflow-hidden"
                                onClick={() => setSelectedIndex(index)}
                            >
                                <img
                                    src={`https://img.youtube.com/vi/${video.youtube_id}/hqdefault.jpg`}
                                    alt={video.title || 'Video'}
                                    className="img-fluid"
                                    loading="lazy"
                                />
                                <div className="video-thumb-play">
                                    <i className="bi bi-play-fill"></i>
                                </div>
                                {video.title && (
                                    <div className="video-thumb-title">{video.title}</div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Modal s přehrávačem videa + navigace mezi videi */}
            <Modal
                show={isOpen}
                onHide={() => setSelectedIndex(null)}
                size="xl"
                centered
                contentClassName="hk-lightbox-content"
                onExited={() => setSelectedIndex(null)}
            >
                <Modal.Body className="hk-lightbox-body text-center p-2">
                    {isOpen && (
                        <>
                            <button
                                type="button"
                                className="hk-lightbox-close"
                                onClick={() => setSelectedIndex(null)}
                                aria-label="Zavřít"
                            >
                                <i className="bi bi-x-lg"></i>
                            </button>

                            {videos.length > 1 && (
                                <button
                                    type="button"
                                    className="hk-lightbox-nav hk-lightbox-nav-prev"
                                    onClick={showPrev}
                                    aria-label="Předchozí"
                                >
                                    <i className="bi bi-chevron-left"></i>
                                </button>
                            )}

                            <div className="ratio ratio-16x9 hk-lightbox-video">
                                <iframe
                                    src={`https://www.youtube.com/embed/${videos[selectedIndex].youtube_id}?autoplay=1`}
                                    title="YouTube video"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    className="rounded"
                                ></iframe>
                            </div>

                            {videos.length > 1 && (
                                <button
                                    type="button"
                                    className="hk-lightbox-nav hk-lightbox-nav-next"
                                    onClick={showNext}
                                    aria-label="Další"
                                >
                                    <i className="bi bi-chevron-right"></i>
                                </button>
                            )}

                            {videos.length > 1 && (
                                <div className="hk-lightbox-counter">
                                    {selectedIndex + 1} / {videos.length}
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Videos;
